import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class LoggingService {
  private readonly isProd = environment.production;

  /** Informational — dev only. */
  info(message: string, ...optionalParams: any[]): void {
    if (!this.isProd) {
      console.log(`[INFO] ${message}`, ...optionalParams);
    }
  }

  /** Unexpected but recoverable condition — always logged. */
  warn(message: string, ...optionalParams: any[]): void {
    console.warn(`[WARN] ${message}`, ...optionalParams);
  }

  error(message: string): void;
  error(message: string, error: any): void;
  error(message: string, error: any, ...optionalParams: any[]): void;
  /** Failure that requires investigation — always logged + forwarded to monitoring in prod. */
  error(message: string, error?: any, ...optionalParams: any[]): void {
    if (error !== undefined) {
      console.error(`[ERROR] ${message}`, error, ...optionalParams);
    } else {
      console.error(`[ERROR] ${message}`);
    }
    if (this.isProd) {
      this.sendToExternalLoggingService(message, error);
    }
  }

  /** Verbose trace — dev only, requires "Verbose" filter in DevTools. */
  debug(message: string, ...optionalParams: any[]): void {
    if (!this.isProd) {
      console.debug(`[DEBUG] ${message}`, ...optionalParams);
    }
  }

  log(level: 'info' | 'warn' | 'error' | 'debug', message: string, ...optionalParams: any[]): void {
    switch (level) {
      case 'info':
        this.info(message, ...optionalParams);
        break;
      case 'warn':
        this.warn(message, ...optionalParams);
        break;
      case 'error':
        this.error(message, optionalParams.length ? optionalParams : undefined);
        break;
      case 'debug':
        this.debug(message, ...optionalParams);
        break;
    }
  }

  /**
   * Forward to an external monitoring service in production.
   * Integrate with Sentry / Azure Application Insights / CloudWatch when available.
   */
  private sendToExternalLoggingService(_message: string, _error?: any): void {
    // Integration point — no-op until a monitoring service is configured.
  }
}
